import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="header">
          <h1 className="title">Christian Reed</h1>
          <p className="description">I'm a front-end web developer, cyclist, outdoor enthusiast, and maker based in Seattle Washington.</p>
        </header>
        <section className="section personal">
          <h2 className="title">Personal</h2>
          <p className="description">In my spare time I enjoy riding bikes off-road, and racing them with enthusiastic mediocrity. I'm also really getting into backpacking.</p>
          <p className="description">Here's where I'm more or less active on the Web.</p>
          <ul className="links">
            <li className="link-item"><a className="link" href="https://blog.christianreed.org">Blog</a></li>
            <li className="link-item"><a className="link" href="https://www.instagram.com/mashmal/">Instagram</a></li>
            <li className="link-item"><a className="link" href="https://www.strava.com/athletes/97771">Strava</a></li>
          </ul>
        </section>
        <section className="section professional">
          <h2 className="title">Professional</h2>
          <p className="description">I've been a web developer for over a decade. I specialize in front-end development, with an emphasis on design systems for large sites, semantic markup, mobile responsive, and accessibility.</p>
          <ul className="links">
            <li className="link-item">I do freelance work through <a className="link" href="https://rgbfab.com">RGB Fabrication</a></li>
            <li className="link-item">I also write a <a className="link" href="https://blog.rgbfab.com">blog</a> there</li>
            <li className="link-item"><a className="link" href="https://www.linkedin.com/in/chrstnrd/">LinkedIn</a></li>
            <li className="link-item"><a className="link" href="https://github.com/christianreed">GitHub</a></li>
          </ul>
        </section>
        <section className="section contact">
          <h2 className="title">Contact</h2>
          <ul className="links">
            <li className="link-item"><a className="link" href="mailto:christian@christianreed.org">christian@christianreed.org</a></li>
          </ul>
        </section>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js